import {AccountModel, ActivityModel, ShippingTruckTypeModel, AddressModel} from "@coreModels";

export class QuoteOrdersModel {
  quote_and_orders?: any;
  project?: any;
  type?: any;
  status?: any;
  status_changed?: any;
  contact?: any;
  account?: any;
  address?: any;
  guest_user_id?: any;
  total_amount?: any;
  slip_rating?: any;
  id?: any;
  guid?: any;
  order_id?: any;
  frontend_user_id?: any;
  delivery_address_id?: any;
  project_name?: any;
  in_shipping_zone?: any;
  subtotal?: any;
  delivery_cost?: any;
  tax_gst?: any;
  applied_credit?: any;
  applied_discount_price?: any;
  final_total?: any;
  quote_status?: any;
  quote_status_name?: any;
  notes?: any;
  warehouse_arrival_date?: any;
  is_archive?: any | null;
  created_at?: any;
  modified_at?: any;
  status_changed_at?: any;
  deliveryAddress?: any;
  quoteProducts?: any;
  quoteStatusLog?: any;
  quotePayments?: any;
  frontendUser?: AccountModel;
  backendUser?: AccountModel;
  delivery_instructions?: any;
  note?: any;
  shipping_truck_type_id?: any;
  description?: any;
  is_pushed_bigpost?: any;
  is_expired?: any;
  expire_date?: any;
  leadTime?: any;
  shipping_rate?: any;
  lead_time?: any;
  frontendUserAddresses?: AddressModel;
  available_credit?: any;
  deposit_amount?: any;
  deposit_amount_percentage?: any
  final_due_amount?: any
  final_amount_due?: any;
  final_amount?: any;
  eligible_credit_amount?: any;
  new_credit?: any;
  quoteStatus?: any | null;
  applied_credit_percent?: any;
  order_number?: any;
  quote_number?: any;
  shippingTruckType?: ShippingTruckTypeModel;
  shipping_zone?: any;
  activities?: ActivityModel[];
  total?: any;
  deposit?: any;
  site_contact_name?: any;
  site_contact_number?: any;
  site_contact_email?: any;
  isDepositPaid?: boolean;
  isFinalPaymentPaid?: boolean;
  isFullPaymentPaid?: boolean;
  finalAmountDue?: any;
  isShippingCostAdded?: boolean;
  orderStatus?: any;
  quoteFeedback?: any;
  delivery_date?: string;
  no_of_pallet?: any;
  delivery_address_line_1?: any;
  delivery_address_line_2?: any;
  delivery_suburb?: any;
  delivery_town_city?: any;
  delivery_state_region?: any;
  delivery_post_code?: any;
  delivery_country?: any;
  isApproveQuote?: boolean;
  premiumAdhesiveExpand?: boolean;
  premiumSealerExpand?: boolean;
  acceptedActivity?: any;
  progress_bar_width?: any;
  days_to_expiry?: any;
  expiredActivity?: any;
  stock_required_date?: any;
  total_premium_sealing_price?: any = 0;
  total_adhesive_price?: any = 0;
  is_select_premium_sealing?: boolean = false;
  is_select_adhesive?: boolean = false;
  carrier_id?: any
  is_consumable_calculator_applied?: any
  total_applied_calculator_price?: any
  carrier?: any
  is_used_own_transport?: any;
  company?: any;
  is_draft?: any;
  company_address_id?: any;
  frontend_user_address_id?: any;
  total_adhesive_premium_price?: any;
  carrier_status_id?: any;
  export_id?: any;
  amount?: any;
  carrierStatus?: any;
  is_manual_shipping_rate_change?: any;
  isEditableSiteOrderDetails?: any;
  disabledAdhesivePrice?: boolean;
  disabledSealerPriceDefender?: boolean;
  disabledSealerPriceGold?: boolean;
  disabledTotalAdhesivePrice?: boolean;
  disabledTotalPremiumSealingPrice?: boolean;
  is_deleted?: any;
  quoteOverallSealerUnit?: any;
  credit_card_surcharge?: any;
  is_credit_card_charge_show?: any;
  total_adhesive_calculator_price?: any;
  total_sealer_calculator_price?: any;
  is_disable_expiry_deadline?: string;
  quote_order_status_detail?: any;
  quoteOrderStatusHistories?: any;
  quoteOrderStatusList?: any;
  is_warehouse_collection?: any;
  frontend_user_bpay_biller_code?: any;
  frontend_user_bpay_reference?: any;
  total_surfaces_and_accessories?: any;
  total_premium_adhesive?: any;
  total_premium_sealing?: any;
  gross_amount?: any;
  applied_discount?: any;
  total_partial_paid_amount?: any;
  is_deposit_payment_paid?: any;
  deposit_payment_processing?: any;
  final_payment_processing?: any;
  full_payment_processing?: any;
  is_payment_processing?: boolean;
  is_deposit_slider_adjust?: any;
  total_weight ?:any;
  tracking_id?:any;
  is_stock_required_date_confirm?:any
  quoteOrderReactivatedActivities?:any;
  total_rrp_amount?:any;
  trade_discount?:any;
  trade_discount_percentage ?:any
  is_select_default_business_address ?:any
  next_stock_arrival ?:any
  credit_specifier_id ?:any
}
